import { Pause } from "@/shared/foundation/icons";
import { Banner, RobotoButton } from "@/shared/foundation/primitives";

/**
 * Says a rule's saved action is switched off. `onResume` turns it back on;
 * without it, no Resume button is offered.
 */
export function PausedBanner({
  actionName,
  onResume,
  resuming = false,
}: {
  actionName: string;
  onResume?: () => void;
  resuming?: boolean;
}) {
  return (
    <Banner
      variant="warning"
      data-testid="auto-ingest-paused"
      icon={<Pause aria-hidden="true" />}
      description={
        <>
          <strong>Auto-ingest is paused.</strong> Saved action{" "}
          <code>{actionName}</code> isn&rsquo;t running.
        </>
      }
      action={
        onResume === undefined ? undefined : (
          <RobotoButton
            variant="secondary"
            size="sm"
            onClick={onResume}
            loading={resuming}
          >
            Resume
          </RobotoButton>
        )
      }
    />
  );
}
